
import * as angular from "angular";
import { ITimelineEntry } from "./timeline.component";
import "./timelineEntry.scss";

interface IComponentController {
    entry: ITimelineEntry;
}

class ComponentController implements angular.IComponentController, IComponentController {

    loading: boolean;

    entry: ITimelineEntry;

    static $inject = ["$element", "$transclude"];

    constructor(
        private readonly $element: angular.IAugmentedJQuery,
        private readonly $transclude: angular.ITranscludeFunction) {
    }

    $onInit() {
    }

    $onChanges(onChangesObj: angular.IOnChangesObject): void {
    }
}

export class TimelineEntryComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;
    transclude: boolean;

    constructor() {
        this.bindings = {
            entry: "<",
        };

        this.transclude = true;

        this.controller = ComponentController;
        this.template = require("./timelineEntry.html");
    }
}
